import * as types from './constants';

const initialState = {
  data: {},
  saveLoading: false,
  errors_api: {}
};

const actions = {
  // Edit Account Phone
  [types.EDIT_ACCOUNT_PHONE_REQUEST]: state => {
    const data = {
      ...state,
      saveLoading: true
    };

    return { ...data };
  },

  [types.EDIT_ACCOUNT_PHONE_DONE]: (state, { payload }) => {
    const data = {
      ...state,
      saveLoading: false,
      data: payload
    };

    return { ...data };
  },

  [types.EDIT_ACCOUNT_PHONE_FAILED]: (state, { payload }) => {
    const data = {
      ...state,
      saveLoading: false,
      errors_api: payload
    };

    return { ...data };
  },

  [types.EDIT_ACCOUNT_PHONE_RESET]: () => {
    const data = {
      ...initialState
    };

    return { ...data };
  }
};

export default (state = initialState, action) => {
  if (actions[action.type]) return actions[action.type](state, action);
  return state;
};